import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Il `cn()` che ogni componente shadcn si aspetta di trovare qui. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
